import { createContext } from 'react';

const CookiesConsentContext = createContext({
  openCookiesSettings: () => {},
});

export default CookiesConsentContext;
